import React, { Dispatch, useState } from 'react';
import SearchImage from '../../../assets/images/Search.svg';
import Filter from '../../../assets/images/Filter.svg';
import style from './CounterpartySearch.module.scss';

interface IProps {
  showAdvancedSearch: boolean;
  setShowAdvancedSearch: Dispatch<boolean>;
  onSubmit: (searchValue: string) => void;
  setAdvancedSearchValue: Function;
  value: string;
  okpd2Codes: string[];
}

const SuppliersSearch: React.FC<IProps> = ({
  showAdvancedSearch,
  setShowAdvancedSearch,
  onSubmit,
  setAdvancedSearchValue,
  value,
  okpd2Codes,
}: IProps) => {
  const [isError, setError] = useState({ isError: false, errorMessage: '', showError: true });

  const handleClick = async () => {
    if (value.trim() === '' && !okpd2Codes.length) {
      setError({
        isError: true,
        errorMessage: 'Для выполнения поиска заполните ключевые слова и/или ОКПД2',
        showError: true,
      });
      return;
    }
    setError({ isError: false, errorMessage: '', showError: false });

    onSubmit(value);
  };

  return (
    <div className={style.searchContainer}>
      <h3 className={style.title}>Введите ключевые слова</h3>

      <form className={style.search}>
        <div className={style.group}>
          <input
            type="search"
            className={style.searchInput}
            value={value}
            onChange={(event) => setAdvancedSearchValue(event.target.value)}
            onBlur={() => setError((prev) => ({ ...prev, showError: false }))}
            onFocus={() => {
              if (value.trim() !== '') setError((prev) => ({ ...prev, showError: true }));
            }}
          />
          {isError.isError && isError.showError && <div className={style.error}>{isError.errorMessage}</div>}
        </div>

        <button
          type="button"
          className={style.filterButton}
          onClick={() => {
            setShowAdvancedSearch(!showAdvancedSearch);
          }}
        >
          <img src={Filter} alt="Поиск" className={style.searchImage} />
          Расширенный поиск
        </button>

        <button
          type="submit"
          className={style.searchButton}
          onClick={(event) => {
            event.preventDefault();
            handleClick();
            setTimeout(() => {
              setError((prev) => ({ ...prev, showError: false }));
            }, 5000);
          }}
        >
          <img src={SearchImage} alt="Поиск" className={style.searchImage} />
          Найти
        </button>
      </form>
    </div>
  );
};

export default SuppliersSearch;
